module.exports = __webpack_public_path__ + "static/img/aepic-2.f2089d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-2.jpg
// module id = Z01P
// module chunks = 52